import { Star, Quote } from 'lucide-react';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Rajesh Kumar',
      role: 'Director, Real Estate',
      company: 'Urban Nest Properties, Noida',
      image: 'https://static.prod-images.emergentagent.com/jobs/530bf07d-b9ef-426c-bee3-64db76b4583b/images/a7516215f96d9cc170873cbec23d4001a0945ce6fe8ab734f91d7e5aaa730d04.png',
      rating: 5,
      text: 'Ashvya Digital Media transformed our lead generation completely. We went from 50 leads per month to 800+ qualified leads. Their Meta Ads expertise is unmatched!',
    },
    {
      name: 'Dr. Priya Sharma',
      role: 'Chief Administrator',
      company: 'Sunrise Multi-specialty Hospital, Ghaziabad',
      image: 'https://static.prod-images.emergentagent.com/jobs/530bf07d-b9ef-426c-bee3-64db76b4583b/images/5aed7010ee44bc0a998265e28e45c2c6c23c213c691cc579dbf99f6f71019ab8.png',
      rating: 5,
      text: 'The strategic approach to healthcare marketing was exactly what we needed. Patient inquiries increased by 60% within 3 months. Highly professional team!',
    },
    {
      name: 'Amit Verma',
      role: 'Founder & CEO',
      company: 'StyleHub Fashion, Delhi',
      image: 'https://static.prod-images.emergentagent.com/jobs/530bf07d-b9ef-426c-bee3-64db76b4583b/images/52401a19585e130e61a7b6bd46cf896379b2cb1f955a4c7761f73649cf6bd2d8.png',
      rating: 5,
      text: 'Their reels and social media content went viral multiple times! We grew from 5K to 50K followers in 6 months. Sales increased by 400%. Amazing ROI!',
    },
    {
      name: 'Neha Gupta',
      role: 'Marketing Head',
      company: 'TechVenture Solutions, Noida',
      image: 'https://static.prod-images.emergentagent.com/jobs/530bf07d-b9ef-426c-bee3-64db76b4583b/images/956d21ece756ce1fac1e018c2005e11f4a06c1e3f0e24fcdd35cbf6544bf0be8.png',
      rating: 5,
      text: 'Best digital marketing agency in NCR! Their Google Ads campaigns delivered 300% ROI. The team is responsive, creative, and results-driven.',
    },
    {
      name: 'Vikram Singh',
      role: 'Owner',
      company: 'Heritage Builders, Greater Noida',
      image: 'https://static.prod-images.emergentagent.com/jobs/530bf07d-b9ef-426c-bee3-64db76b4583b/images/50c1182239028afecc1154cbc7101b926e2ba600086faca63da3bb3216024769.png',
      rating: 5,
      text: 'Working with Ashvya has been a game-changer. Their understanding of the real estate market in NCR is exceptional. Highly recommend for lead generation!',
    },
    {
      name: 'Anita Desai',
      role: 'Director',
      company: 'Wellness Spa & Clinic, Modinagar',
      image: 'https://static.prod-images.emergentagent.com/jobs/530bf07d-b9ef-426c-bee3-64db76b4583b/images/64a87dac3395caf4def696a4ca15473092a9c46a2c84ed3bffac5874464e276e.png',
      rating: 5,
      text: 'From website development to social media management, everything was handled professionally. Our online bookings doubled in just 2 months!',
    },
  ];

  return (
    <section id="testimonials" className="py-24 md:py-32 bg-white" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-teal-600 mb-4 block">
            Client Testimonials
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900 mb-6">
            What Our Clients Say About Us
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Don't just take our word for it. Here's what businesses across NCR say about working with us.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="testimonials-grid">
          {testimonials.map((testimonial) => (
            <div
              key={`${testimonial.name}-${testimonial.company}`}
              className="bg-slate-50 border border-slate-200 rounded-2xl p-8 shadow-sm hover:shadow-lg transition-all duration-300 relative"
              data-testid={`testimonial-card-${testimonial.name.replace(/\s+/g, '-').toLowerCase()}`}
            >
              <div className="absolute top-6 right-6 opacity-10">
                <Quote className="w-16 h-16 text-teal-600" />
              </div>

              <div className="relative z-10">
                <div className="flex items-center gap-4 mb-6">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full object-cover border-2 border-teal-500"
                  />
                  <div>
                    <h4 className="font-bold text-slate-900">{testimonial.name}</h4>
                    <p className="text-sm text-slate-600">{testimonial.role}</p>
                    <p className="text-xs text-teal-600 font-medium">{testimonial.company}</p>
                  </div>
                </div>

                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={`star-${testimonial.name}-${i}`} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>

                <p className="text-slate-700 leading-relaxed italic">"{testimonial.text}"</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;